import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
export const useEffectJustChanges = (callback, dependencies) => {
  const $ = _c(4);
  const reference = useRef(false);
  let t0;
  if ($[0] !== callback) {
    t0 = () => {
      if (reference.current) {
        return callback?.();
      }
      reference.current = true;
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== dependencies) {
    t1 = dependencies || [];
    $[2] = dependencies;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
};